import { useEffect } from 'react';

import { useDrawerControls } from 'components/common/zolaUI/Drawer';

export function useBudgetSetOnSave(onSave: () => void, depsList?: React.DependencyList) {
  const { setOnSave } = useDrawerControls();
  useEffect(() => {
    // update callback on any form field changes so
    // the unsaved changes prompt has up-to-date values
    setOnSave(onSave);
    return () => {
      setOnSave();
    };
  }, depsList); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useBudgetSetOnSave;
